import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { PageResultDto } from 'interfaces/page';
import { ScheduleOverrideDto, ScheduleOverrideListItemDto, ScheduleOverrideQueryDto } from 'interfaces/schedules/overrides';

interface ScheduleOverridesService {
  search(employeeId: string, queryParams?: ScheduleOverrideQueryDto): Promise<PageResultDto<ScheduleOverrideListItemDto>>;
  get(employeeId: string, date: string, signal?: AbortSignal): Promise<ScheduleOverrideDto>;
  create(employeeId: string, date: string, postData: ScheduleOverrideDto): Promise<void>;
  delete(employeeId: string, date: string): void;
}

const endpoints = {
  search: (employeeId: string) => `/employees/${employeeId}/schedules/overrides`,
  get: (employeeId: string, date: string) => `/employees/${employeeId}/schedules/overrides/${date}`,
  create: (employeeId: string, date: string) => `/employees/${employeeId}/schedules/overrides/${date}`,
  delete: (employeeId: string, date: string) => `/employees/${employeeId}/schedules/overrides/${date}`,
};

export const employeeOverridesService: ScheduleOverridesService = {
  search: async (employeeId: string, queryParams?: ScheduleOverrideQueryDto): Promise<PageResultDto<ScheduleOverrideListItemDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<ScheduleOverrideListItemDto>>> = await apiClient.get(
      endpoints.search(employeeId),
      { params: { ...queryParams } },
    );

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  get: async (employeeId: string, date: string, signal?: AbortSignal): Promise<ScheduleOverrideDto> => {
    const response: AxiosResponse<ApiResponseDto<ScheduleOverrideDto>> = await apiClient.get(endpoints.get(employeeId, date), { signal });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  create: async (employeeId: string, date: string, postData: ScheduleOverrideDto): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.put(endpoints.create(employeeId, date), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
  delete: async (employeeId: string, date: string): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<void>> = await apiClient.delete(endpoints.delete(employeeId, date));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
};
